import React = require("react")
import { Action, AsyncState, Widget, mkWidget } from "widgets-for-react";
import { FormState } from "../../form/types";
import { Vacancy } from "../custom_pages/types.mod";
import { t } from 'i18next'
import { vacancyHeaderButtonFormDatalayer } from "../../datalayer";
import { Breadcrumbs } from '../templates/breadcrumbs.mod'
import { List } from 'immutable'
import HeroVisual, { VacancyTypeCheck } from "./heroVisual";

export type CustomVacancyDetailPageHeader = {
  vacancy: Vacancy
  set_state: (output: Action<{
    get_vacancy: AsyncState<Vacancy>,
    form: FormState,
    current_view: "vacancy-detail" | "apply-form"
  }>) => void
}

export const getDetailPageHeaderImage = (department: string) => {

  switch (department?.toLowerCase()) {
    case "administration":
      return "Administration"

    case "engineering":
    case "maintenance":
    case "technical":
      return "Engineering"

    case "health, safety & environment":
    case "health, safety - environment":
    case "health & safety":
      return "Health, Safety & Environment"

    case "hr":
    case "human resources":
      return "HR"

    case "finance & it":
    case "finance - it":
    case "finance/accounting":
    case "finance accounting/report":
    case "information technology":
    case "information systems":
    case "control":
    case "accounting":
      return "Finance-IT"

    case "manufacturing":
    case "operations":
    case "continuous improvement":
      return "Manufacturing"

    case "purchasing":
    case "purchasing/procurement":
      return "Purchasing"

    case "sales & marketing":
    case "sales - marketing":
    case "marketing":
    case "sales":
    case "commerce":
    case "commercialization":
      return "Sales Marketing"

    case "quality":
      return "Quality"

    case "supply chain":
    case "demand & supply chain":
    case "supply chain logistics":
    case "supply chain planning":
      return "Supply Chain"

    // No warehouse image 
    case "warehouse":
      return "Warehouse"

    default:
      // General Management
      // Communication
      // Research & Development
      // Customer Service
      // Legal
      // Print Production Group
      // Other
      return "Other"
  }
}

export const vacancyDetailPageHeader = (currentLang, careersSlug, careersTitle, vacancy: Vacancy,
  set_state: (output: Action<{ get_vacancy: AsyncState<Vacancy>, form: FormState, current_view: "vacancy-detail" | "apply-form" }>) => void
) => mkWidget({
  run: _ => {
    const applyButtonOnClick = _ => {
      set_state(s => ({ ...s, current_view: "apply-form" }))
      vacancyHeaderButtonFormDatalayer(t("Vacancy:apply_now"))
    }
    return (<header className={`pageheader no-image pageheader--flat`}>
      <div className="pageheader__inner">
        <div className="pageheader__content container container--m">
          <div className="pageheader__message">
            <div className="pageheader__header">
              <div className="pageheader__breadcrumbs">
                <Breadcrumbs
                  breadcrumbs={List([
                    {
                      url: `/${currentLang}/`,
                      title: 'Home'
                    },
                    {
                      url: `/${currentLang}/${careersSlug}`,
                      title: `${careersTitle}`
                    },
                  ])}
                />
              </div>
              <h1 className="pageheader__title">{vacancy.Name}</h1>
              {/* <div className={"pageheader__intro"} dangerouslySetInnerHTML={{ __html: vacancy.Description }} /> */}
            </div>
          </div>

          <HeroVisual
            hasFixedImg={false}
            hasCMSImg={false}
            hasVacancyImg={true}
            vacancy={VacancyTypeCheck(getDetailPageHeaderImage(vacancy.Department?.toLowerCase()).toLowerCase())} />
        </div>
      </div>

      <div className="container container--m grid--gutter">
        <div className="pageheader__search-bar grid--gutter">
          <div className="pageheader__info">
            <ul className="pageheader__list">
              {vacancy.City && infoItem(vacancy.City, 'pin', 24, 16)}
              {vacancy.IsFulltime ? infoItem(t("Vacancy:fulltime"), 'clock', 24, 22) : infoItem(t("Vacancy:parttime"), 'clock', 24, 22)}
              {vacancy.Department &&
                infoItem(t(`search:tag_${getDetailPageHeaderImage(vacancy.Department)?.replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
                  , 'department', 22, 22)
              }
            </ul>
          </div>
          <button className="button button--primary"
            onClick={applyButtonOnClick}>
            <span> {t("Vacancy:apply_now")} </span>
          </button>
        </div>
      </div>
    </header>)
  }
})


export const vacancyOverviewPageHeader = (currentLang, careersSlug, careersTitle) =>
  mkWidget({
    run: _ => {
      return <header className="pageheader pageheader--flat no-image">
        <div className="pageheader__inner">
          <div className="pageheader__content container container--m">
            <div className="pageheader__message">
              <div className="pageheader__header">
                <div className="pageheader__breadcrumbs">
                  <Breadcrumbs
                    breadcrumbs={List([
                      {
                        url: `/${currentLang}/`,
                        title: 'Home'
                      },
                      {
                        url: `/${currentLang}/${careersSlug}`,
                        title: `${careersTitle}`
                      },
                      {
                        url: `/${currentLang}/${careersSlug}/vacancies`,
                        title: t("Vacancy:title_our_vacancies")
                      }
                    ])}
                  />
                </div>
                <h1 className="pageheader__title">{t("Vacancy:title_our_vacancies")}</h1>
              </div>
            </div>
          </div>
        </div>
      </header>
    }
  })


export const vacancyApplicationFormPageHeader = (title: string) => mkWidget({
  run: _ => {
    return <header className={`pageheader no-image`}>
      <div className="pageheader__inner">
        <div className="pageheader__content container container--m">
          <div className="pageheader__message">
            <div className="pageheader__header">
              <h1 className="pageheader__title">{title}</h1>
            </div>
          </div>
          <div className={`pageheader__visual no-image`} />
        </div>
      </div>
    </header>
  }
})


export const infoItem = (title: string, icon: string, height: number, width: number) => {
  return (
    <li className="pageheader__item">
      <span>{title}</span>
      <svg className="pageheader__icon" aria-hidden="true" height={height} width={width}>
        <use xlinkHref={`#icon--${icon}`} />
      </svg>
    </li>
  )
}